export function extendObjectWithId<T>(objectArray: Array<T>, propertyAsId: string) {
  return objectArray.map((x) => {
    return { ...x, id: x[propertyAsId] };
  });
}
